module.exports = __webpack_public_path__ + "media/images/icon/mail-12fbec3356d1472a63d9aba5abd0a3fa.svg";